var map = {
	"./ampguard.png": 945,
	"./ampguard.webp": 1097,
	"./bivieh-yt.png": 8186,
	"./bivieh-yt.webp": 6830,
	"./book-minecraft.png": 2245,
	"./book-minecraft.webp": 7185,
	"./book.png": 3093,
	"./book.webp": 6343,
	"./deinplugin.png": 1748,
	"./hsmwmobil.png": 1973,
	"./hsmwmobil.webp": 7296,
	"./lokallabore.png": 6877,
	"./lokallabore.webp": 9972,
	"./md-events.png": 2160,
	"./schloool-web.png": 5429,
	"./schloool-yt.png": 7234,
	"./schloool-yt.webp": 787,
	"./statera.png": 6437,
	"./studisq.png": 7501,
	"./web-congress.jpg": 6574,
	"./what-the-shape.png": 9762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904;